/**
 * Which Stripe publishable key should THIS browser tokenize against?
 *
 * THE DEFECT THIS EXISTS TO CLOSE
 * ===============================
 * `process.env.STRIPE_PUBLIC_KEY` is substituted into the bundle by
 * dotenv-webpack at BUILD time -- ONE key for the whole deployment. The
 * backend became per-distributor when every charge path moved to
 * `client_for(binding.mode)`; the browser did not. Production was built with
 * the legacy SANDBOX platform's `pk_test_`, so a `live`-mode distributor's
 * shopper tokenized a real card against the sandbox platform and Stripe
 * refused it:
 *
 *     Your card was declined. Your request was in test mode, but used a non
 *     test card.
 *
 * Swapping the single build-time key is not a fix -- it mirrors the failure
 * onto the `sandbox`-mode store with real shoppers on it.
 *
 * THE RESOLUTION, AND WHY THE FALLBACK IS THE WAY ROUND IT IS
 * ===========================================================
 * The API now serves `stripe_publishable_key` on the account-lookup payload
 * the storefront already fetches before calling `loadStripe`, resolved from
 * the distributor's `stripe_platform_mode`. The server value WINS; the
 * build-time constant is the fallback.
 *
 * Reversed, the build-time value would shadow a correctly resolved one and
 * silently pin every store to one platform -- on an instance that had been
 * configured properly, with a symptom identical to the defect. That is the
 * same ordering discipline `connect_client_id_for` and `publishable_key_for`
 * apply server-side.
 *
 * The fallback is not decoration. Until the per-mode secrets are written,
 * and on any frontend deployed ahead of its API, the server answers `null`
 * or omits the field entirely -- and behaviour must then be exactly what it
 * is today rather than `loadStripe(null)`, which would break checkout on
 * every store at once.
 *
 * A publishable key is safe in client-side JavaScript by design. It is still
 * configuration: nothing here logs a value.
 */

/**
 * The key to hand `loadStripe`, given an account-lookup response body.
 *
 * @param {object|null|undefined} payload the body of
 *   `/stripe/getStripeAccountId` or `/stripe/getStripeAccountIdFromCampaign`
 * @returns {string|undefined} the server-resolved key when the API supplied
 *   one, otherwise the value this bundle was built with
 */
export function resolvePublishableKey(payload) {
  const served = payload && payload.stripe_publishable_key;
  // A non-empty STRING only. `null` (nothing configured), `undefined` (an
  // API predating this field), and `""` all mean "the server has no answer",
  // and each must route to the fallback rather than reach Stripe.js.
  if (typeof served === "string" && served.trim()) {
    return served.trim();
  }
  return process.env.STRIPE_PUBLIC_KEY;
}

/** The value baked into this bundle, for components with no store in scope. */
export function buildTimePublishableKey() {
  return process.env.STRIPE_PUBLIC_KEY;
}
